import { ajax } from 'cadenza/api-client/api';
import { type MapObjectSelection, MIMETYPE_JSON } from 'cadenza/api-client/api-constants';
import type { DimensionDto } from 'cadenza/api-client/dto/dimension-dto';
import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';
import type { UploadedFileDto } from 'cadenza/api-client/dto/uploaded-file-dto';

const SHAPEFILE_IMPORT_ENDPOINT = '/shapefileImport';

export function importUploadedShapefiles (files: UploadedFileDto[], mapId: string) {
  return ajax<void>(`/map/${mapId}/layers`, {
    type: 'POST',
    data: JSON.stringify(files),
    contentType: MIMETYPE_JSON
  });
}

export function getMaxUploadSize () {
  return ajax<number>(SHAPEFILE_IMPORT_ENDPOINT + '/maxUploadSize');
}

export function startExport (mapId: string, selectedLayer: string, mapSize: DimensionDto, mapExtent: WorldBoxDto, mapObjectSelection: MapObjectSelection) {
  return ajax(`/maps/${mapId}/layers/${selectedLayer}/shape?mapSize=${mapSize}&mapExtent=${mapExtent}&mapObjectSelection=${mapObjectSelection}`);
}

export function getAvailableExportOptions (mapId: string, selectedLayer: string, mapSize: DimensionDto, mapExtent: WorldBoxDto): Promise<MapObjectSelection[]> {
  return ajax(`/maps/${mapId}/layers/${selectedLayer}/shape?mapSize=${mapSize}&mapExtent=${mapExtent}`, {
    headers: {
      Accept: MIMETYPE_JSON
    },
    method: 'OPTIONS'
  });
}
